<script>
  import Button, {
    ICON, SMALL_ICON, DEFAULT,
  } from './Button.svelte';
  import Icon from '../Icon';

  export let icon;
  export let small = false;
  export let appearance = DEFAULT;

  let button;

  $: size = small ? SMALL_ICON : ICON;
  export function focus() {
    button.focus();
  }
</script>

<Button secondary {size} {appearance} {...$$restProps} on:click bind:this={button}>
  <Icon {icon} />
</Button>
